import React, { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";

export const NewsletterForm = ({ source = "homepage", testid = "newsletter-form" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email, source });
      setDone(true);
      setEmail("");
      toast.success("You're on the list. Welcome to DWC.");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = Array.isArray(detail) ? detail[0]?.msg : detail;
      toast.error(msg || "Couldn't subscribe — please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid={testid}
      className="flex flex-col sm:flex-row items-stretch gap-0 border border-black/15 bg-white"
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@email.com"
        className="flex-1 px-5 py-4 text-sm outline-none placeholder:text-ink-muted bg-transparent"
        data-testid={`${testid}-email`}
        aria-label="Email address"
      />
      <button
        type="submit"
        disabled={loading}
        className="bg-ink text-white px-6 py-4 text-[11px] uppercase tracking-[0.22em] hover:bg-brand transition-colors disabled:opacity-60"
        data-testid={`${testid}-submit`}
      >
        {loading ? "Joining…" : done ? "Joined ✓" : "Be First to Receive"}
      </button>
    </form>
  );
};

export default NewsletterForm;
